import { CommonModule } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
} from "@angular/forms";
import { EditorModule } from "primeng/editor";
import { ButtonModule } from "primeng/button";

@Component({
  selector: "jni-editor",
  templateUrl: "./editor.component.html",
  styleUrls: ["./editor.component.scss"],
  imports: [CommonModule, EditorModule, ReactiveFormsModule, ButtonModule],
})
export class EditorComponent implements OnChanges {
  @Output() sendEmail = new EventEmitter<string>();
  @Output() templateEvent = new EventEmitter<string>();
  emailForm!: FormGroup;
  @Input() displaySendButton = true;

  @Input() htmlBody = "";
  constructor(private _fb: FormBuilder) {
    this.initializeForm();
  }

  initializeForm() {
    this.emailForm = this._fb.group({
      body: new FormControl([""]),
    });
  }

  ngOnChanges() {
    if (this.htmlBody) {
      this.emailForm.get("body")?.setValue(this.htmlBody);
    }
  }

  setTemplateValue() {
    this.emailForm.get("body")?.setValue(this.htmlBody);
  }

  send() {
    this.sendEmail.emit(this.emailForm.get("body")?.value);
  }
}
